import React, { useContext, useEffect, useState } from 'react'

import { MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact'

import { useParams } from 'react-router-dom'
import EditPlayer from '../components/Admin/Player/templates/EditPlayer'
import PlayerStats from '../components/Public/Player/PlayerStats'
import ViewJarallax from '../components/View/ViewJarallax'
import { firestore } from '../firebase'
import StateContext from '../StateContext'

function SinglePlayerPage() {
    const { id } = useParams()

    const { userId, loggedIn } = useContext(StateContext)

    const [show, setShow] = useState(false)

    const [player, setPlayer] = useState()

    function toggleModal() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    useEffect(() => {
        try {
            const playerRef = firestore.collection('players-fb').doc(id)
            playerRef.onSnapshot((doc) => {
                const player = { id: doc.id, ...doc.data() }
                setPlayer(player)
            })
        } catch (error) {
            console.log(error)
        }
    }, [id])

    return (
        <div>
            <ViewJarallax text={player && player.player_name} />
            <div>
                <div className="player-background text-white">
                    <div className="mask rgba-black-strong">
                        <div className="row">
                            <div className="col-md-4">
                                <img
                                    src={player?.player_image}
                                    alt={player?.player_name}
                                    className="img-fluid"
                                />
                            </div>
                            <div className="col-md-8">
                                <div
                                    className="col-lg-8 py-5 px-5"
                                    style={{ fontSize: '0.9rem' }}
                                >
                                    <p>
                                        Lag:{' '}
                                        <span className="float-right text-white-50">
                                            {player?.player_team}
                                        </span>
                                    </p>
                                    <p>
                                        Kamper:{' '}
                                        <span className="float-right text-white-50">
                                            {player?.player_total_fixtures || 0}
                                        </span>
                                    </p>
                                    <p>
                                        Mål:{' '}
                                        <span className="float-right text-white-50">
                                            {player?.player_total_goals || 0}
                                        </span>
                                    </p>
                                    <p>
                                        Assist:{' '}
                                        <span className="float-right text-white-50">
                                            {player?.player_total_assists || 0}
                                        </span>
                                    </p>
                                    <p>
                                        Draktnummer:{' '}
                                        <span className="float-right text-white-50">
                                            {player?.player_number || 0}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white">
                        <PlayerStats playerId={id} />
                    </div>
                </div>
                {loggedIn &&
                    userId === 'aqX59RalZnV1sHLpS6UA1b5b4992' &&
                    player && (
                        <div className="container">
                            <button onClick={() => setShow(true)}>
                                Rediger
                            </button>
                            <MDBModal
                                size="lg"
                                isOpen={show}
                                toggle={toggleModal}
                            >
                                <MDBModalHeader toggle={toggleModal}>
                                    Oppdater spiller
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <EditPlayer player={player} />
                                </MDBModalBody>
                            </MDBModal>
                        </div>
                    )}
            </div>
        </div>
    )
}
export default SinglePlayerPage
